export const AGENDA_TASK_CREATION = 'sessionCreation'
export const AGENDA_TASK_PUBLICATION = 'publication'
export const AGENDA_TASK_BLIND_PUBLICATION = 'blindPublication'
export const AGENDA_TASK_ASSIGNMENT = 'assignment'

export const AGENDA_DATE_START = 'startsAt'
export const AGENDA_DATE_END = 'endsAt'

export const AGENDA_TASKS_PARTNER = [
  AGENDA_TASK_BLIND_PUBLICATION,
  AGENDA_TASK_PUBLICATION,
  AGENDA_TASK_ASSIGNMENT,
]

export const AGENDA_TASKS = [AGENDA_TASK_CREATION, ...AGENDA_TASKS_PARTNER]

export const AGENDA_STATE_PLANNED = 'planned'
export const AGENDA_STATE_OPEN = 'open'
export const AGENDA_STATE_CLOSED = 'closed'

export const AGENDA_STATES = [
  AGENDA_STATE_PLANNED,
  AGENDA_STATE_OPEN,
  AGENDA_STATE_CLOSED,
]
